import React, { useId, useState } from 'react';
import { Check, GraduationCap, Repeat2, Trophy } from 'lucide-react';
import MarkdownText from './MarkdownText';
import CardActionsMenu from './CardActionsMenu';
import { getGraduationStamp } from '../utils/graduationStamp';
import { vocabularyGrade, vocabularyGraduationType } from '../utils/vocabularyPresentation';
import { t } from '../i18n';
import './VocabularyWordCard.css';

const v = (key, values) => t(`vocabulary.${key}`, undefined, values);
export default function VocabularyWordCard({ card, direction = 'q_to_a', disabled, onExclude, onEdit }) {
  const [revealed, setRevealed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const memoId = useId();
  // Keep backMemo on the back face, matching vocabulary practice in either direction.
  const front = direction === 'a_to_q' ? card.A ?? card.back : card.Q ?? card.front;
  const back = direction === 'a_to_q' ? card.Q ?? card.front : card.A ?? card.back;
  const grade = vocabularyGrade(card);
  const graduationType = vocabularyGraduationType(card);
  const isNew = card.isNew && !graduationType;
  const stampLabel = graduationType === 'early' ? 'wordKnownStamp' : graduationType === 'manual' ? 'wordCanceledStamp' : 'wordComplete';
  return <div className={`flashcard-map-item vocabulary-word-card vocabulary-grade-${grade}${graduationType ? ' has-graduation-stamp' : ''}${menuOpen ? ' is-menu-open' : ''}`}>
    <div className="vocabulary-preview-face">
      <button type="button" className={`flashcard-map-content vocabulary-preview-card${revealed ? ' is-revealed' : ''}`} disabled={disabled}
        aria-pressed={revealed} aria-label={v('previewFlip', { word: revealed ? back : front })}
        aria-describedby={revealed && card.backMemo ? memoId : undefined} onClick={() => setRevealed(current => !current)}>
        {isNew && <span className="vocabulary-preview-new">New</span>}
        <span className="flashcard-map-text vocabulary-preview-word"><MarkdownText text={revealed ? back : front} />
          {revealed && card.backMemo && <span id={memoId}><MarkdownText className="vocabulary-preview-memo" text={card.backMemo} /></span>}
        </span>
        {graduationType && <img className="vocabulary-word-stamp" src={getGraduationStamp(graduationType)} alt={v(stampLabel)} title={v(stampLabel)} />}
      </button>
    </div>
    <div className="flashcard-map-stats vocabulary-word-footer">
    <div className="flashcard-map-stat-line vocabulary-word-stats" role="group" aria-label={v('wordStats', { word: card.Q ?? card.front })}>
      <span aria-label={v('wordRepeats', { count: card.repeatCount || 0 })} title={v('wordRepeats', { count: card.repeatCount || 0 })}><Repeat2 size={14} aria-hidden="true" />{card.repeatCount || 0}</span>
      <span aria-label={v('wordPoints', { points: card.totalPoints || 0 })} title={v('wordPoints', { points: card.totalPoints || 0 })}><Trophy size={14} aria-hidden="true" />{card.totalPoints || 0}</span>
      <span aria-label={v('wordGrade', { grade })} title={v('wordGrade', { grade })}><GraduationCap size={14} aria-hidden="true" />{grade}</span>
      {onEdit && <CardActionsMenu disabled={disabled} onEdit={onEdit} onOpenChange={setMenuOpen} />}
    </div>
    {isNew && onExclude ? <button type="button" className="vocabulary-preview-known" disabled={disabled}
      aria-label={v('previewKnownWord', { word: front })} onClick={onExclude}><Check size={16} aria-hidden="true" />{v('previewKnown')}</button> : null}
    </div>
  </div>;
}
